import React from "react";
import "./index.scss";
import DropdownImg from "../../assets/images/Frame 2227.png";
import ExpandImg from "../../assets/images/Frame 2227 (1).png";
import Compare from "../../pages/compare";

const Card = ({
  headerContent,
  bodyContent,
  footerContent,
  isDetailsVisible = false,
  toggleDetailsVisibility,
  upscale_type,
}) => {
  return (
    <>
      <div className="insurance--card">
        {/* Card Header */}
        <div
          className={`insurance--card--header ${
            upscale_type === "RECOMMENDED" ? "insurance--recommended" : ""
          }`}
        >
          {headerContent}
        </div>

        {/* Card Content */}
        <div className="insurance--card--content">{bodyContent}</div>

        {/* Details Visibility Toggle */}

        {/* Card Footer */}
        {toggleDetailsVisibility ? (
          <div className="horizontal--line--wrapper">
            <div className="horizontal--line"></div>
            <img
              src={isDetailsVisible ? ExpandImg : DropdownImg}
              alt={isDetailsVisible ? "Collapse" : "Expand"}
              onClick={toggleDetailsVisibility}
              style={{ cursor: "pointer" }}
            />
          </div>
        ) : (
          <div className="horizontal--line--wrapper">
            <div className="horizontal--line"></div>
          </div>
        )}

        <div className="insurance--card--body">
          <div className="insurance--card--footer">{footerContent}</div>
        </div>
      </div>
    </>
  );
};

export default Card;
